import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/patient-regimen";

export const pagingPatientRegimen = (searchObject) => {
  var url = API_PATH + "/pagingPatientRegimen";
  return axios.post(url, searchObject);
};

export const getListPatientRegimen = (obj) => {
  let url = API_PATH + "/listPatientRegimen";
  return axios.post(url, obj);
};

export const getListPatientRegimenByRegimen = (id) => {
  let url = API_PATH + "/get-list-patient-regimen-by-regimen/" + id;
  return axios.get(url);
};

export const prePatientRegimenByEncounterDate = (obj) => {
  let url = API_PATH + "/pre-patient-regimen-by-encounter-date";
  return axios.post(url, obj);
};
